import {SingleScoDataMap} from "scorm/common/SingleScoDataMap";
import {Scorm2004} from "./ScormModelIDs";

export function SingleSco2004Data(){

    const lmsRelevant = [
        Scorm2004.LOCATION,
        Scorm2004.COMPLETION_STATUS,
        Scorm2004.SUCCESS_STATUS,
        Scorm2004.EXIT,
        Scorm2004.SCORE_RAW,
        Scorm2004.PROGRESS_MEASURE
    ];

    // lms values
    let scoData = new SingleScoDataMap([
        [Scorm2004.COMPLETION_THRESHOLD, "0.8"],
        [Scorm2004.CREDIT, "credit"],
        [Scorm2004.LOCATION, "index"],
        [Scorm2004.COMPLETION_STATUS, ""],
        [Scorm2004.SUCCESS_STATUS, ""],
        [Scorm2004.EXIT, ""],
        [Scorm2004.SCORE_MIN, "0"],
        [Scorm2004.SCORE_MAX, "1"],
        [Scorm2004.SCORE_RAW, ""],
        [Scorm2004.SESSION_TIME, "00:00:00"],
        [Scorm2004.SUSPEND_DATA, ""],
        [Scorm2004.PROGRESS_MEASURE, ""]
    ]);

    function isNotAttempted(){
        return scoData.get(Scorm2004.COMPLETION_STATUS) === "not attempted";
    }

    return {
        set: scoData.set,
        get: scoData.get,
        isValid: scoData.isValid,
        isNotAttempted: isNotAttempted,
        isCourseManagedValue: (dataModelId) => {
            return dataModelId === Scorm2004.COMPLETION_THRESHOLD
                || dataModelId ===Scorm2004.CREDIT;
        },
        checkSuspendDataSize: () => {
            const suspendData = scoData.get(Scorm2004.SUSPEND_DATA);
            return suspendData.length < 64000;
        },
        forEachLmsRelevantValue: function( callback ){
            lmsRelevant.forEach( ( dataModelId ) => {

                const value = scoData.get( dataModelId );
                if( !value ) {
                    return;
                }

                if (dataModelId === Scorm2004.COMPLETION_STATUS && isNotAttempted()) {
                    return;
                }

                callback( value, dataModelId );
            });
        }
    };
}
